export default "__VITE_ASSET__c3ed6fa9__"